var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"awardContainer",style:(_vm.bgStyle)},[_c('div',{staticClass:"amount"},[_vm._v(_vm._s(_vm.awardData.totalAmount))]),_c('div',{staticClass:"label"},[_vm._v("积分")])])
}
var staticRenderFns = []

export { render, staticRenderFns }